import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import moment from 'moment';
import axiosInstance, { addComma, EVENT_ID, getEventId, saveDeadline, stripHtml, WEB_API } from '../constatns';
import CssBaseline from '@material-ui/core/CssBaseline';
import AdminTopbar from './AdminTopbar';
import { BarChart, Create, Delete } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Popout from 'react-popout-new';
import AdminFooter from './AdminFooter';
import SaveIcon from '@material-ui/icons/Save';
import SpeakerSubmissionForm from '../speaker/SpeakerSubmissionForm';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';
import TableToolbarExtra from '../components/MuiDataTableCustom/TableToolbarExtra';
import Table from '../components/Table/Table';
import { CountryList } from '../common/CountryList';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      // minWidth: 100,
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  chartDialogTitle: {
    '& > .MuiTypography-root': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& svg': {
      cursor: 'pointer',
    },
  },
  registerStateTable: {
    '& td:last-child > div': {
      display: 'flex',
      '& > div:first-child': {
        paddingRight: '1em',
      },
      '& > div:last-child': {
        paddingLeft: '1em',
      },
      '& > div:nth-child(2)': {
        padding: '0 1em',
        borderLeft: '1px solid #000',
        borderRight: '1px solid #000',
      },
    },
  },
}));

const SpeakerListPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selectFilter, setSelectFilter] = useState('all');
  const [selectTypeFilter, setSelectTypeFilter] = useState('all');
  const [open, setOpen] = useState(false);
  const [selectData, setSelectData] = useState(false);
  const [openUrl, setOpenUrl] = useState('');
  const [openPreview, setOpenPreview] = useState(false);
  const [openUrlPreview, setOpenUrlPreview] = useState('');
  const [openResend, setOpenResend] = useState(false);
  const [openUrlResend, setOpenUrlResend] = useState('');
  const EVT = JSON.parse(sessionStorage.getItem('EVENT'));
  const [deadline, setDeadline] = useState(
    EVT && EVT.speakerDeadline ? EVT.speakerDeadline : moment().format('YYYY-MM-DDTHH:mm').toString(),
  );

  // 통계 관련 state
  const [openChart, setOpenChart] = useState(false);
  const [count, setCount] = useState({});
  const [country, setCountry] = useState([]);

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'speakerRegNo',
      label: '접수번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'isReg',
      label: '사전등록여부',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return data[tableMeta.rowIndex].userInfo && data[tableMeta.rowIndex].userInfo.isPay === 'P' ? 'X' : 'O';
        },
      },
    },
    {
      name: 'isPay',
      label: '등록비결제',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return data[tableMeta.rowIndex].userInfo &&
            data[tableMeta.rowIndex].userInfo.isPay === 'R' &&
            data[tableMeta.rowIndex].userInfo.status === 'Complete'
            ? 'O'
            : 'X';
        },
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const _color = value === 'Complete' ? 'blue' : 'red';
          return (
            <span style={{ color: _color }} onClick={(e) => console.log('')}>
              {value}
            </span>
          );
        },
      },
    },
    {
      name: 'writer',
      label: 'ID',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          // return value.replace(EVENT_ID + '_', '');
          return value;
        },
      },
    },
    {
      name: 'country',
      label: 'Country',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value;
          // return data[tableMeta.rowIndex] && data[tableMeta.rowIndex].country;
        },
      },
    },
    {
      name: 'firstName',
      label: 'Name',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return `${value} ${tableMeta.currentTableData[tableMeta.rowIndex].data[tableMeta.columnIndex + 1]}`;
        },
      },
    },
    {
      name: 'lastName',
      label: 'lastName',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
        download: false,
      },
    },
    {
      name: 'session',
      label: 'Session',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'noteTitle',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const _info = data[tableMeta.rowIndex];
          return (
            <span className={classes.link} onClick={(e) => showPreview(_info.id)}>
              {value}
            </span>
          );
        },
      },
    },
    {
      name: 'noteContent',
      label: 'Body',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'isUseLaptop',
      label: '개인노트북 사용여부',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    // {
    //   name: 'checkVod',
    //   label: 'VOD 다시보기 동의',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //   },
    // },
    // {
    //   name: 'check1',
    //   label: 'E-Learning 동의여부 1',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //   },
    // },
    // {
    //   name: 'check2',
    //   label: 'E-Learning 동의여부 2',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //   },
    // },
    // {
    //   name: 'check3',
    //   label: 'E-Learning 동의여부 3',
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     display: false,
    //   },
    // },
    {
      name: 'accountHolder',
      label: '예금주',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'bank',
      label: '은행명',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'bankAccount',
      label: '계좌번호',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'cvfile',
      label: 'CV Upload',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? <a href={encodeURI(value.path).replace(/\+/g, '%2B')}>{value.name}</a> : '';
        },
      },
    },
    {
      name: 'createdAt',
      label: '접수일',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return dt.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss');
        },
      },
    },
    {
      name: 'updatedAt',
      label: '최종 수정일',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return value ? dt.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss') : '';
        },
      },
    },
    // {
    //   name: 'reviewStatus',
    //   label: '심사결과',
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return '-';
    //     },
    //   },
    // },
    {
      name: 'figures1',
      label: 'Figures 1',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures2',
      label: 'Figures 2',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures3',
      label: 'Figures 3',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures4',
      label: 'Figures 4',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures5',
      label: 'Figures 5',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'figures6',
      label: 'Figures 6',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    // {
    //   name: 'file',
    //   label: '발표파일',
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return '-';
    //     },
    //   },
    // },
    {
      name: 'id',
      label: 'Mail',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button color={'primary'} size={'small'} variant={'contained'} disableElevation onClick={(e) => sendEmail(value)}>
              Resend
            </Button>
          );
        },
      },
    },
    {
      name: 'id',
      label: '관리',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const isDel = selectFilter === 'cancel';
          return (
            <div>
              <IconButton aria-label="update" onClick={() => setUpdateAction(value, tableMeta, updateValue)}>
                <Create fontSize="small" />
              </IconButton>
              <IconButton aria-label="delete" onClick={() => setDeleteAction(tableMeta)}>
                <Delete fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const sendEmail = (val) => {
    setOpenUrlResend(`/#/admin/Resend?type=speaker&id=${val}`);
    if (openResend) {
      setOpenResend(false);
      setTimeout(function () {
        setOpenResend(true);
      }, 300);
    } else {
      setOpenResend(true);
    }
  };

  const showPreview = (val) => {
    if (val) {
      setOpenUrlPreview(`/#/admin/speaker/Preview?speakerId=${val}`);
    } else {
      setOpenUrlPreview(`/#/admin/speaker/Preview`);
    }
    if (openPreview) {
      setOpenPreview(false);
      setTimeout(function () {
        setOpenPreview(true);
      }, 300);
    } else {
      setOpenPreview(true);
    }
  };

  const setUpdateAction = (val, meta, updateVal) => {
    if (selectFilter === 'cancel') {
      swal({
        title: '선택한 항목을 복구하시겠습니까?',
        text: '',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .put(`${WEB_API}/speaker/restore`, {
              eventId: EVENT_ID,
              speakerId: data[meta.rowIndex].id,
            })
            .then((res) => {
              setSelectFilter('all');
              getSpeakerData();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    } else {
      setSelectData(data[meta.rowIndex]);
      if (open) {
        setOpen(false);
        setTimeout(function () {
          setOpen(true);
        }, 300);
      } else {
        setOpen(true);
      }
    }
  };

  const setDeleteAction = (meta) => {
    swal({
      title: '정말 삭제하시겠습니까?',
      text: selectFilter === 'cancel' ? '삭제 후 복구할수 없습니다.' : '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (selectFilter === 'cancel') {
          axiosInstance
            .delete(`${WEB_API}/speaker/?eventId=${EVENT_ID}&speakerId=${data[meta.rowIndex].id}`)
            .then((res) => {
              getSpeakerData();
              handleFilter('cancel');
            })
            .catch((err) => {
              console.error(err);
            });
        } else {
          axiosInstance
            .put(`${WEB_API}/speaker/del`, {
              eventId: EVENT_ID,
              speakerId: data[meta.rowIndex].id,
            })
            .then((res) => {
              getSpeakerData();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      }
    });
  };

  const options = {
    print: false,
    filterType: 'dropdown',
    viewColumns: false,
    downloadOptions: {
      filename: `speaker_${moment().valueOf()}.xls`,
    },
    searchOpen: true,
    selectableRows: 'none',
    customToolbar: () => {
      return <TableToolbarExtra onPreview={onPreview} onDownload={onDown} />;
    },
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              const val = value.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              const search = searchQuery.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              if (val.indexOf(search) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, _data) => {
      const author = columns.findIndex((d) => d.name === 'firstName');
      const dt = columns.findIndex((d) => d.name === 'createdAt');
      const content = columns.findIndex((d) => d.name === 'noteContent');
      const cvfile = columns.findIndex((d) => d.name === 'cvfile');
      const useLaptop = columns.findIndex((d) => d.name === 'isUseLaptop');
      const checkVod = columns.findIndex((d) => d.name === 'checkVod');
      const check1 = columns.findIndex((d) => d.name === 'check1');
      const check2 = columns.findIndex((d) => d.name === 'check2');
      const check3 = columns.findIndex((d) => d.name === 'check3');
      const bankAccount = columns.findIndex((d) => d.name === 'bankAccount');
      const figures1 = columns.findIndex((d) => d.name === 'figures1');
      const figures2 = columns.findIndex((d) => d.name === 'figures2');
      const figures3 = columns.findIndex((d) => d.name === 'figures3');
      const figures4 = columns.findIndex((d) => d.name === 'figures4');
      const figures5 = columns.findIndex((d) => d.name === 'figures5');
      const figures6 = columns.findIndex((d) => d.name === 'figures6');
      const file = columns.findIndex((d) => d.name === 'file');

      let retVal = [];
      _data.map((_d) => {
        if (author !== -1) {
          _d.data[author] = `${_d.data[author]} ${data[_d.index].lastName}`;
        }
        if (dt !== -1) {
          _d.data[dt] = moment(Number(_d.data[dt])).format('YYYY-MM-DD HH:mm');
        }
        if (content !== -1) {
          _d.data[content] = stripHtml(_d.data[content]);
        }
        if (cvfile !== -1 && _d.data[cvfile]) {
          _d.data[cvfile] = '=HYPERLINK("' + encodeURI(_d.data[cvfile].path).replace(/\+/g, '%2B') + '","' + _d.data[cvfile].name + '")';
        }
        if (useLaptop !== -1 && _d.data[useLaptop]) {
          _d.data[useLaptop] = _d.data[useLaptop] && _d.data[useLaptop] === 'true' ? 'Y' : 'N';
        }
        if (checkVod !== -1 && _d.data[checkVod]) {
          _d.data[checkVod] = _d.data[checkVod] && _d.data[checkVod] === 'true' ? 'Y' : 'N';
        }
        if (check1 !== -1 && _d.data[check1]) {
          _d.data[check1] = _d.data[check1] && _d.data[check1] === 'true' ? 'Y' : 'N';
        }
        if (check2 !== -1 && _d.data[check2]) {
          _d.data[check2] = _d.data[check2] && _d.data[check2] === 'true' ? 'Y' : 'N';
        }
        if (check3 !== -1 && _d.data[check3]) {
          _d.data[check3] = _d.data[check3] && _d.data[check3] === 'true' ? 'Y' : 'N';
        }
        if (bankAccount !== -1 && _d.data[bankAccount]) {
          _d.data[bankAccount] = _d.data[bankAccount] ? "'" + _d.data[bankAccount] : '';
        }
        if (figures1 !== -1 && _d.data[figures1]) {
          _d.data[figures1] = '=HYPERLINK("' + _d.data[figures1].path + '","' + _d.data[figures1].name + '")';
        }
        if (figures2 !== -1 && _d.data[figures2]) {
          _d.data[figures2] = '=HYPERLINK("' + _d.data[figures2].path + '","' + _d.data[figures2].name + '")';
        }
        if (figures3 !== -1 && _d.data[figures3]) {
          _d.data[figures3] = '=HYPERLINK("' + _d.data[figures3].path + '","' + _d.data[figures3].name + '")';
        }
        if (figures4 !== -1 && _d.data[figures4]) {
          _d.data[figures4] = '=HYPERLINK("' + _d.data[figures4].path + '","' + _d.data[figures4].name + '")';
        }
        if (figures5 !== -1 && _d.data[figures5]) {
          _d.data[figures5] = '=HYPERLINK("' + _d.data[figures5].path + '","' + _d.data[figures5].name + '")';
        }
        if (figures6 !== -1 && _d.data[figures6]) {
          _d.data[figures6] = '=HYPERLINK("' + _d.data[figures6].path + '","' + _d.data[figures6].name + '")';
        }
        if (file !== -1 && _d.data[file]) {
          _d.data[file] = '=HYPERLINK("' + _d.data[file].path + '","' + _d.data[file].name + '")';
        }
        retVal.push(_d);
        return _d;
      });
      const body = buildBody(retVal).replace(/\'/gi, '');
      return '\uFEFF' + buildHead(columns) + body;
    },
  };

  const getSpeakerData = (_isDel) => {
    console.log('getSpeakerData >>>');
    let url = `${WEB_API}/speaker/list?eventId=${getEventId()}&limit=-1`;
    if (_isDel) {
      url += '&isDel=true';
    }
    axiosInstance.get(`${url}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      // console.log(response.data);
      const _data = response.data.sort((a, b) => {
        return Number(b.createdAt) - Number(a.createdAt);
      });
      setData(_data);
      if (!_isDel) {
        setAllData(_data);
      }
    });
  };

  const onPreview = () => {
    showPreview();
  };
  const onDown = () => {
    setOpenUrlPreview(`/#/admin/speaker/Preview?type=download`);
    if (openPreview) {
      setOpenPreview(false);
      setTimeout(function () {
        setOpenPreview(true);
      }, 300);
    } else {
      setOpenPreview(true);
    }
  };

  const doSaveDeadline = () => {
    saveDeadline(deadline, 'speakerDeadline');
  };

  useEffect(() => {
    getSpeakerData();
  }, []);

  const handleClose = () => {
    console.log('Window Close');
    getSpeakerData();
    setOpen(false);
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else {
      getSpeakerData(true);
    }
  };

  const showChart = () => {
    setCount({
      total: data.length,
      korean: 0,
      international: 0,
      basicresearch: 0,
      craniofacial: 0,
      handupperlimb: 0,
      headneck: 0,
      breastbody: 0,
      lowerlimb: 0,
    });

    // 총등록자 및 세션별
    data.map((item) => {
      setCount((prevState) => ({
        ...count,
        total: prevState['total'],
        korean: item.country === 'Korea, Republic of' ? prevState['korean'] + 1 : prevState['korean'],
        international: item.country !== 'Korea, Republic of' ? prevState['international'] + 1 : prevState['international'],
        basicresearch:
          item.session && item.session === '기초연구 (Basic Research)' ? prevState['basicresearch'] + 1 : prevState['basicresearch'],
        craniofacial:
          item.session && item.session === '두개안면 및 외상 (Craniofacial & Trauma)'
            ? prevState['craniofacial'] + 1
            : prevState['craniofacial'],
        handupperlimb:
          item.session && item.session === '수부 및 상지 재건 (Hand & Upper Limb Reconstruction)'
            ? prevState['handupperlimb'] + 1
            : prevState['handupperlimb'],
        headneck:
          item.session && item.session === '두경부 재건 (Head and Neck Reconstruction)' ? prevState['headneck'] + 1 : prevState['headneck'],
        breastbody:
          item.session && item.session === '유방 체부 재건 (Breast Body Reconstruction)'
            ? prevState['breastbody'] + 1
            : prevState['breastbody'],
        lowerlimb:
          item.session && item.session === '하지재건 (Lower Limb Reconstruction)' ? prevState['lowerlimb'] + 1 : prevState['lowerlimb'],
      }));
    });

    // 국가별
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      // if (CountryList[i].name !== 'Korea, Republic of') {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
      // }
    }
    if (data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < buff.length; j++) {
          if (buff[j].name === data[i].country) {
            buff[j].count += 1;
          }
        }
      }
    }
    setCountry(buff);

    setOpenChart(true);
  };

  const handleTypeFilter = (_filter) => {
    setSelectTypeFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else if (_filter === 'korean') {
      const newData = alldata.filter((d) => {
        return d.country.indexOf('Korea') !== -1;
      });
      setData(newData);
    } else {
      const newData = alldata.filter((d) => {
        return d.country.indexOf('Korea') === -1;
      });
      setData(newData);
    }
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={4} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Speaker Abstract</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All Abstract
                </Button>
                <Button variant={selectFilter === 'cancel' ? 'contained' : 'outlined'} onClick={() => handleFilter('cancel')}>
                  Cancel List
                </Button>
              </ButtonGroup>
            </Grid>
            <Grid item>
              <Grid container alignItems={'center'} justifyContent={'center'}>
                <Grid item>
                  <TextField
                    style={{ marginRight: 5 }}
                    id="datetime-local"
                    label="초록등록 마감 일시"
                    type="datetime-local"
                    defaultValue={deadline}
                    onChange={(e) => setDeadline(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button color="secondary" variant={'outlined'} startIcon={<SaveIcon />} onClick={doSaveDeadline} disableElevation>
                    저장
                  </Button>
                </Grid>
                <Grid item style={{ marginLeft: '100px' }}>
                  <Button
                    color="primary"
                    variant={'outlined'}
                    startIcon={<BarChart />}
                    disableElevation
                    onClick={() => history.push('/admin/speakerStatus')}
                  >
                    통계
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginBottom: '1em' }}>
          <ButtonGroup color="primary" disableElevation>
            <Button variant={selectTypeFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleTypeFilter('all')}>
              All
            </Button>
            <Button variant={selectTypeFilter === 'korean' ? 'contained' : 'outlined'} onClick={() => handleTypeFilter('korean')}>
              Korean
            </Button>
            <Button
              variant={selectTypeFilter === 'international' ? 'contained' : 'outlined'}
              onClick={() => handleTypeFilter('international')}
            >
              International
            </Button>
          </ButtonGroup>
        </Grid>
        <Grid item>
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableFilterList: TableFilterList }}
          />
        </Grid>
      </Grid>
      <AdminFooter />
      {openPreview ? (
        <Popout url={openUrlPreview} title="PRS2021-ADMIN-SPEAKERPREVIEW" onClosing={handleClose} options={{ width: 1200, height: 800 }} />
      ) : null}
      {openResend ? (
        <Popout url={openUrlResend} title="PRS2021-ADMIN-SPEAKERRESEND" onClosing={handleClose} options={{ width: 850, height: 800 }} />
      ) : null}
      {open ? (
        <Dialog
          open={open}
          fullWidth
          maxWidth={'lg'}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <SpeakerSubmissionForm
            mode={'modify'}
            abstractId={selectData.id}
            isPop={true}
            isAdmin={true}
            infoData={selectData}
            handleClose={handleClose}
          />
        </Dialog>
      ) : null}
      {openChart ? (
        <Dialog open={openChart} onClose={() => setOpenChart(false)}>
          <DialogTitle className={classes.chartDialogTitle}>
            Speaker 통계
            <CloseIcon onClick={() => setOpenChart(false)} />
          </DialogTitle>
          <DialogContent dividers>
            <h3>총 등록자</h3>
            <Table>
              <TableBody className={classes.registerStateTable}>
                <TableRow>
                  <TableCell>등록현황</TableCell>
                  <TableCell>
                    <div>
                      <div>전체 : {count['total']}</div>
                      <div>국내 : {count['korean']}</div>
                      <div>해외 : {count['international']}</div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <h3>세션별</h3>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>세션이름</TableCell>
                  <TableCell>인원</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>기초연구 (Basic Research)</TableCell>
                  <TableCell align="center">{count['basicresearch']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>두개안면 및 외상 (Craniofacial & Trauma)</TableCell>
                  <TableCell align="center">{count['craniofacial']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>수부 및 상지 재건 (Hand & Upper Limb Reconstruction)</TableCell>
                  <TableCell align="center">{count['handupperlimb']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>두경부 재건 (Head and Neck Reconstruction)</TableCell>
                  <TableCell align="center">{count['headneck']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>유방 체부 재건 (Breast Body Reconstruction)</TableCell>
                  <TableCell align="center">{count['breastbody']}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>하지재건 (Lower Limb Reconstruction)</TableCell>
                  <TableCell align="center">{count['lowerlimb']}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <h3>국가별</h3>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>국가명</TableCell>
                  <TableCell>인원</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {country.map(
                  (item) =>
                    item.count > 0 && (
                      <TableRow key={item.name}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell align="center">{item.count}</TableCell>
                      </TableRow>
                    ),
                )}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default SpeakerListPage;
